exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".icon-field .md-icon[data-v-d6b405e6] {\n  color: inherit !important;\n}\n.color-form-group[data-v-d6b405e6] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.color-picker[data-v-d6b405e6] {\n  border: none;\n  padding: 0;\n  margin: 0;\n}\n.tooltip-icon[data-v-d6b405e6] {\n  color: inherit !important;\n}\n.display-icon[data-v-d6b405e6] {\n  padding-top: 5px;\n}\n", ""]);

// exports
